import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'react-loading';

import DefaultInput from '../../components/Input';
import Button from '../../components/Button';
import Logo from '../../assets/images/logo-parquearauco.png';
import Icon from '../../assets/images/logo.png';
import {
  Container,
  Wrapper,
  Title,
  PreTitle,
  IconImg,
  Footer,
  CustomLink
} from './styles';

import { signIn } from '../../store/actions/AuthActions';
import { loginSchema } from './constants';

export default function Login() {
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [{ usernameError, passwordError }, setErrors] = useState({
    userError: false,
    passwordError: false
  });

  const loading = useSelector(state => state.auth.loading);

  function handleUsernameOnChange(e) {
    setUsername(e.target.value);
  }

  function handlePasswordOnChange(e) {
    setPassword(e.target.value);
  }

  function handleOnClick() {
    submit();
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      submit();
    }
  }

  async function submit() {
    try {
      setErrors({ userError: false, passwordError: false });

      await loginSchema.validate({ username, password }, { abortEarly: false });

      dispatch(signIn(username, password));
    } catch (err) {
      err.inner &&
        err.inner.map(error =>
          setErrors(prevState => ({
            ...prevState,
            [`${error.path}Error`]: true
          }))
        );
    }
  }

  return (
    <Container data-testid="login-component">
      <IconImg src={Logo} />
      <Title>
        <PreTitle>SISTEMAS </PreTitle>AUTENTICACIÓN
      </Title>
      <Wrapper>
        <p>Iniciar sesión</p>
        <DefaultInput
          label="USUARIO"
          name="name"
          placeholder="Usuario"
          placeholderColor="#bbb"
          onChange={handleUsernameOnChange}
          value={username}
          onKeyDown={handleKeyDown}
          error={usernameError}
        />
        <DefaultInput
          label="CONTRASEÑA"
          type="password"
          name="password"
          placeholder="Contraseña"
          placeholderColor="#bbb"
          onChange={handlePasswordOnChange}
          value={password}
          onKeyDown={handleKeyDown}
          error={passwordError}
        />
        <Button
          text={
            loading ? (
              <Loading height={15} width={15} type="spin" />
            ) : (
              'Ingresar'
            )
          }
          onClick={handleOnClick}
        />

        <CustomLink to="/contrasena-perdida">Olvidé mi contraseña</CustomLink>
      </Wrapper>
      <Footer>
        <IconImg src={Icon} />
      </Footer>
    </Container>
  );
}
